// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  title: 'Integrate',
  connectionDetected: 'Connection detected',
  step: 'Step {n}',
  status: {
    current: 'Current',
    done: 'Done',
    reference: 'Reference',
    guideOpened: 'Guide opened',
  },
  avatar: {
    title: 'Choose an avatar',
    label: 'Avatar',
    placeholder: 'Select an avatar',
    publicGroup: 'Public Avatars',
    customGroup: 'Custom Avatars',
    unavailable: 'This avatar is unavailable — choose another avatar',
    idLabel: 'Avatar ID',
    copyId: 'Copy avatar ID',
  },
  key: {
    title: 'Get an API key',
    manage: 'Manage keys',
    appLabel: 'App',
    appPlaceholder: 'Select an app',
    create: 'Create key',
    createNote: 'Create an app to group your credentials and generate your first API key',
    keyLabel: 'API key',
    keyPlaceholder: 'Select an available key',
    keyOption: '{key} · created {date}',
    keyUnavailable: 'This key is no longer available — choose another key',
    appUnavailable: 'This app is unavailable — choose another app',
    appIdLabel: 'App ID',
    copyAppId: 'Copy app ID',
    clientTag: 'Client',
    serverTag: 'Server only',
    show: 'Show API key',
    hide: 'Hide API key',
    copyKey: 'Copy API key',
    noKey: 'No API key yet',
    generate: 'Generate key',
    note: 'Use the IDs in your client and keep the API key on your server',
  },
  build: {
    title: 'Start building',
    demo: {
      title: 'Run the demo',
      summary: 'Run a sample locally to try a talking avatar before adding it to your app',
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
      quickstart: '{label} quickstart',
      more: 'Sample project on GitHub',
    },
    sdk: {
      title: 'Integrate the SDK',
      summary: 'Add AvatarKit to your product, starting with how audio reaches the avatar',
      compare: 'Compare integrations',
      more: 'SDK reference',
    },
    opensInNewTab: '{label} (opens in a new tab)',
  },
  verify: {
    title: 'Verify your integration',
    noApp: 'Select an app to check for connections',
    connected: 'Connections detected from {app} · View them in Session History',
    waiting: 'No connections from {app} yet — check Session History after connecting',
    viewSessions: 'View sessions',
  },
  copied: 'Copied to clipboard',
  copyFailed: 'Copy failed. Select the text and copy it manually.',
}

export const zhCN = {
  title: '接入',
  connectionDetected: '已检测到连接',
  step: '第 {n} 步',
  status: {
    current: '当前',
    done: '已完成',
    reference: '参考',
    guideOpened: '已打开指南',
  },
  avatar: {
    title: '选择人物',
    label: '人物',
    placeholder: '选择一个人物',
    publicGroup: '公共人物',
    customGroup: '自定义人物',
    unavailable: '该人物不可用，请选择其他人物',
    idLabel: 'Avatar ID',
    copyId: '复制 Avatar ID',
  },
  key: {
    title: '获取 API Key',
    manage: '管理 Key',
    appLabel: '应用',
    appPlaceholder: '选择一个应用',
    create: '创建 Key',
    createNote: '创建一个应用来归组凭证并生成第一个 API Key',
    keyLabel: 'API Key',
    keyPlaceholder: '选择一个可用的 Key',
    keyOption: '{key} · 创建于 {date}',
    keyUnavailable: '该 Key 已不可用，请选择其他 Key',
    appUnavailable: '该应用不可用，请选择其他应用',
    appIdLabel: 'App ID',
    copyAppId: '复制 App ID',
    clientTag: '客户端',
    serverTag: '仅服务端',
    show: '显示 API Key',
    hide: '隐藏 API Key',
    copyKey: '复制 API Key',
    noKey: '还没有 API Key',
    generate: '生成 Key',
    note: '两个 ID 可随客户端发布，API Key 请留在服务器',
  },
  build: {
    title: '开始构建',
    demo: {
      title: '运行示例',
      summary: '先在本地跑一个示例，看看会说话的人物效果，再接进你的应用',
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
      quickstart: '{label} 快速开始',
      more: 'GitHub 示例项目',
    },
    sdk: {
      title: '接入 SDK',
      summary: '把 AvatarKit 接进你的产品，先确定音频如何送达人物',
      compare: '对比接入方式',
      more: 'SDK 参考',
    },
    opensInNewTab: '{label}（在新标签页打开）',
  },
  verify: {
    title: '验证接入',
    noApp: '选择一个应用以检查连接记录',
    connected: '已检测到来自 {app} 的连接 · 在会话记录中查看',
    waiting: '{app} 还没有连接记录，连接后到会话记录查看',
    viewSessions: '查看会话',
  },
  copied: '已复制到剪贴板',
  copyFailed: '复制失败，请选中文本手动复制。',
}
